

import forge from "node-forge";
import { private_key } from "../../keys";

async function decryptApi(code){
    //console.log(code)
    const privateKey = forge.pki.privateKeyFromPem(private_key);
    //console.log(privateKey)
    const decodedCiphertext = forge.util.decode64(code);
    //console.log(code.length)
    const deciphered_code = privateKey.decrypt(decodedCiphertext, 'RSA-OAEP')

    //console.log("Decrypted Message:", deciphered_code);
    return deciphered_code   
}


export default decryptApi;